import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';

import { Sidebar } from '../../components/Sidebar';
import api from '@/utils/ky';

export function meta() {
  return [{ title: 'Past Sessions - Hupo AI' }];
}

interface Session {
  id: string;
  type: string;
  medium: 'voice' | 'text';
  startedAt: string;
  endedAt: string;
  context: {
    goal: string;
    theme: {
      title: string;
      reason: string;
    };
  };
  associatedSession?: Session;
}

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return `${date.getDate()} ${date
    .toLocaleString('default', { month: 'short' })
    .toUpperCase()} ${date.getFullYear()}`;
};

function SessionCard({ session }: { session: Session; token: string }) {
  const hasRoleplay = session.associatedSession;

  const formatSessionType = (session) => {
    if (hasRoleplay) {
      return session.medium === 'voice' ? 'VOICE ROLEPLAY' : 'TEXT ROLEPLAY';
    }
    return 'GENERAL COACHING';
  };


  return (
    <div className="rounded-xl border border-gray-200 bg-white p-6">
      <div className="flex justify-between items-center">
        <div className="flex flex-col space-y-2">
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <span>{formatDate(session.startedAt)}</span>
            <span>•</span>
            <span>{formatSessionType(session.associatedSession)}</span>
          </div>

          <h3 className="text-lg font-medium">
            {session.associatedSession?.context.theme.title ||
              session.context.theme.title}
          </h3>
        </div>

      </div>
    </div>
  );
}

export const PastSessions = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token') || '';

  const { data, isLoading, error } = useQuery<{ sessions: Session[] }>({
    queryKey: ['sessions', 'past'],
    queryFn: async () => {
      // API call with token
      if (!token) {
        throw new Error('No authentication token provided');
      }
      return api.get(`api/sessions/past?token=${token}`).json();
    },
  });

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return `${date.getDate()} ${date
      .toLocaleString('default', { month: 'short' })
      .toUpperCase()} ${date.getFullYear()}`;
  };

  // Helper function to format session type for display

  if (error) {
    return (
      <div>
        <Sidebar />
        <div className="py-5 pl-64 pr-5">
          <div className="px-8">
            <h2 className="text-xl font-bold tracking-tight">Past sessions</h2>
            <div className="mt-4 p-6 bg-red-50 text-red-700 rounded-xl">
              Error loading sessions. Please try again.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Sidebar token={token} />

      <div className="py-5 pl-64 pr-5">
        <div className="px-8">
          <h2 className="text-xl font-bold tracking-tight">Past sessions</h2>

          <div className="mt-4 space-y-4">
            {isLoading ? (
              <div className="p-6 bg-white rounded-xl border border-gray-200 flex justify-center">
                <p className="text-gray-600">Loading your past sessions...</p>
              </div>
            ) : data?.sessions && data.sessions.length > 0 ? (
              data.sessions.map((session) => (
                <SessionCard key={session.id} session={session} token={token} />
              ))
            ) : (
              <div className="p-6 bg-white rounded-xl border border-gray-200 text-center">
                <p className="text-gray-600">No past sessions found.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
